(function () {
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-sct-tab]');
    var panels = root.querySelectorAll('[data-sct-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      for (var i = 0; i < tabs.length; i++) {
        var selected = tabs[i].getAttribute('data-sct-tab') === id;
        tabs[i].classList.toggle('is-active', selected);
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', panels[j].getAttribute('data-sct-panel') === id);
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function (e) {
        activate(e.currentTarget.getAttribute('data-sct-tab'));
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sct]');
    for (var i = 0; i < roots.length; i++) {
      initTabs(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
